<!-- Search box -->
<form  [formGroup]="form" class="search-bar-form">
  <div class="search-input">
    <mat-icon>search</mat-icon>
    <input
      formControlName="searchText"
      type="text"
      [placeholder]="placeholder"
      autocomplete="off"
    />
  </div>
</form>
<!-- /Search box -->
